<top-banner variant="title" [title]="selectedContractor?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-card-tabs [tabitems]="tabitems"></app-card-tabs>
          </div>
          <div class="col-md-10">

            <!-- Message for when a user is set up by skylark admin without connecting the site owner to the contractor -->
            <div *ngIf="missingSiteOwnerLink && selectedContractor" class="warning-banner">
              <div class="temporary-information-message">
                <div>
                  <i class="fas fa-info-circle"></i>
                </div>
                <div>
                  <p>
                    There is a data mismatch for this company. Please email Skylark at the <a>controlcentre@skylarkcontrol.com</a> with the following info:
                  </p>
                  <dl class="sideways-dl">
                    <p>Missing contractor to site link</p>
                    <p>Contractor: {{ selectedContractor.id }} - {{ selectedContractor.name }} --- Site Owner: {{ siteOwnerSkylarkUserId }}</p>
                  </dl>
                </div>
              </div>
            </div>

            <h4 class="card-title">Details</h4>
            <div *ngIf="selectedContractor" class="mb-2 animated fadeIn">

              <dl class="sideways-dl">
                <div>
                  <dt>Company Name</dt>
                  <dd>{{selectedContractor.name}}</dd>
                </div>
                <div>
                  <dt>Additional Info</dt>
                  <dd>{{selectedContractor.additionalInfo}}</dd>
                </div>
                <div>
                  <dt>Address</dt>
                  <dd>{{selectedContractor.address}}</dd>
                </div>
                <div>
                  <dt>Main Contact Number</dt>
                  <dd>{{selectedContractor.mainContactNo}}</dd>
                </div>
                <br>
                <ng-container *ngIf="selectedContractor.maintenanceManager">
                  <div>
                    <dt>Manager</dt>
                    <dd>{{selectedContractor.maintenanceManager.firstName}} {{selectedContractor.maintenanceManager.lastName}}</dd>
                  </div>
                  <div>
                    <dt>Email</dt>
                    <dd>{{selectedContractor.maintenanceManager.email}}</dd>
                  </div>
                  <div *ngIf="selectedContractor.maintenanceManager.phoneNumber">
                    <dt>Manager Contact Number</dt>
                    <dd>{{selectedContractor.maintenanceManager.phoneNumber}}</dd>
                  </div>
                </ng-container>
              </dl>
              <div *ngIf="!selectedContractor.maintenanceManager && !isReadOnly">
                <a class="btn btn-success btn-round float-right mt-5" [routerLink]="['/' + routeRole, 'contractors', 'invite']" [queryParams]="{'contractor': selectedContractorId}">Invite a new user account to manage this company</a>
              </div>
              <br>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
